<template>
  <header class="header">
    <router-link class="header__home" :to="{name: 'menu'}">
      <img src="/img/menu.svg" width="25" alt="">
    </router-link>
    <div class="header__name">
      <img class="mr10" src="/img/user.svg" alt="">
      <span>Администратор {{$store.state.user.email}}</span>
      <a class="btn-logout btn--blue" @click="logOut">Выход</a>
    </div>
  </header>
</template>

<script>
  export default {
    name: "Header",
    methods: {
      logOut() {
        localStorage.removeItem('token');
        localStorage.removeItem('email');
        this.$router.push('/');
      }
    }
  }
</script>

<style lang="scss">
  @import "../../style/var";

  .header {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 10px 20px;
    color: #ffffff;
    background-color: $black;
    &__home {
      margin: -3px auto -7px 0;
      padding-right: 20px;
    }
    &__name {
      display: flex;
      align-items: center;
      font-size: 16px;
      @media (max-width: 575px) {
        font-size: 15px;
        .link {
          margin-left: auto !important;
        }
      }
    }
  }
  .btn-logout {
    padding: 13px 20px;
    margin-top: -23px;
    margin-bottom: -19px;
    margin-right: -20px;
    margin-left: 25px;
    cursor: pointer;
  }
</style>